import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=22aeb2d8&scoped=true&"
import script from "./CollectionDetail.vue?vue&type=script&lang=js&"
export * from "./CollectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=22aeb2d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aeb2d8",
  null
  
)

export default component.exports